import clsx from 'clsx'
import Button from 'gu-ui-kit/Button'
import Grid from 'gu-ui-kit/Grid/Container'
import Icon from 'gu-ui-kit/Icon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Logo from 'layouts/subcomponents/Logo'
import styles from 'components/Header/Header.module.scss'
import TicketsCounter from 'components/Header/subcomponents/TicketsCounter'
import { ROUTES } from 'constants/routes'
import BalanceWidget from 'components/Drawer/subcomponents/BalanceWidget'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import { selectAppDrawerState } from 'modules/App/store/selectors'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useAuthState } from 'modules/Auth/hooks/useAuthState'

const Header = ({
  className = '',
  showSidebarToggle = true,
  hasBalance = true,
  faqPath = ROUTES.FAQ,
  openFaqInNewTab = true,
  alwaysShowActions = false,
}) => {
  const { isAuthenticated } = useAuthState()
  const drawerState = useSelector(selectAppDrawerState)
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()
  const { t } = useTranslation(['common'])
  const pathGen = useGeneratePathI18n()
  const showActions = alwaysShowActions || breakpoints.sm

  return (
    <Grid
      className={clsx(styles['header'], 'layout-tile', className)}
      component={'header'}
    >
      <Grid
        alignItems={'center'}
        className={styles['header__width-wrapper']}
        justifyContent={'between'}
      >
        <Grid
          component={'nav'}
          direction={'row'}
          fluid={false}
          gap={16}
          wrap={false}
        >
          <Grid
            className={styles['header__logo']}
            fluid={false}
          >
            <Logo />
          </Grid>

          {isAuthenticated && showSidebarToggle && (
            <Button
              grey
              noLabel
              className={styles['header__sidebar-toggle']}
              size={'s'}
              startIcon={<Icon name={drawerState.opened ? 'close' : 'burger'} />}
              title={t(
                drawerState.opened
                  ? 'common::header.sidebar_toggle_close'
                  : 'common::header.sidebar_toggle_open',
              )}
              variant={'ghost'}
              onPointerDown={(e) => {
                e.preventDefault()

                dispatch({
                  type: SET_DRAWER_STATE,
                  payload: {
                    opened: !drawerState.opened,
                  },
                })
              }}
            />
          )}
        </Grid>

        <Grid
          alignItems={'center'}
          fluid={false}
          gap={16}
          justifyContent={'end'}
          wrap={false}
        >
          <Grid
            alignItems={'center'}
            fluid={false}
            gap={16}
            wrap={false}
          >
            {hasBalance && (
              <BalanceWidget
                className={styles['header__balance-widget']}
                minimalistic={!breakpoints.sm}
                small={true}
              />
            )}

            {showActions && (
              <>
                <Button
                  grey
                  color={'Interface-Eighth'}
                  component={'a'}
                  size={'s'}
                  startIcon={<Icon name={'question'} />}
                  title={t('common::header.faq_link')}
                  variant={'ghost'}
                  {...(openFaqInNewTab ? { target: '_blank' } : {})}
                  href={pathGen(faqPath)}
                />
                <TicketsCounter />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Header

Header.propTypes = {
  className: PropTypes.string,
  showSidebarToggle: PropTypes.bool,
  hasBalance: PropTypes.bool,
  faqPath: PropTypes.string,
  openFaqInNewTab: PropTypes.bool,
  alwaysShowActions: PropTypes.bool,
}
